import React from 'react';
import classNames from 'classnames';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 24,
    background: theme.palette.background.default,
    boxShadow: theme.customShadows.module,
    overflow: 'hidden'
  }
}));

const Module = ({ containerRef, id, className, children }) => {
  const classes = useStyles();

  return (
    <Box
      ref={containerRef}
      id={id}
      className={classNames(classes.root, className)}
    >
      {children}
    </Box>
  );
};

export default Module;
